import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { GetPersonResultDTO } from '../../api/@types/GetPersonResultDTO';

export const useMaxPaymentAmount = (personLoanInfo: GetPersonResultDTO | undefined) => {
  const [maxPaymentAmount, setMaxPaymentAmount] = useState<number>(0);

  useEffect(() => {
    if (personLoanInfo?.totalDue) {
      setMaxPaymentAmount(personLoanInfo.totalDue);
    } else {
      setMaxPaymentAmount(0);
    }
  }, [personLoanInfo]);

  return maxPaymentAmount;
};


export const useInitializePaymentAmount = (
  activeLoan:  GetPersonResultDTO | undefined, 
  setDollars: Dispatch<SetStateAction<string>>, 
  setCents: Dispatch<SetStateAction<string>>
) => {
  useEffect(() => {
    if (activeLoan && activeLoan.lateAmountWithInterest > 0) {
      const totalAmount = activeLoan.lateAmountWithInterest.toFixed(2);
      const [dollarsPart, centsPart] = totalAmount.split('.');
      setDollars(dollarsPart);
      setCents(centsPart);
    }
  }, [activeLoan, setDollars, setCents]);
}
